import { render, staticRenderFns } from "./ShortcutKey.vue?vue&type=template&id=3f89737b&scoped=true"
import script from "./ShortcutKey.vue?vue&type=script&lang=js"
export * from "./ShortcutKey.vue?vue&type=script&lang=js"
import style0 from "./ShortcutKey.vue?vue&type=style&index=0&id=3f89737b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89737b",
  null
  
)

export default component.exports